import { defineMessages } from 'react-intl';

export const aboutYouStepMessages = defineMessages({
  letsPersonalise: {
    defaultMessage: "Let's personalise your experience",
    id: '8T9Wy8yBiy',
    description: 'Title of the onboarding about-you step',
  },
  getStartedInMinutes: {
    defaultMessage: 'Spend just 2 minutes to help you get started.',
    id: 'k25SltnO4c',
    description: 'Subtitle of the onboarding about-you step',
  },
  firstName: {
    defaultMessage: 'First name',
    id: 'vpGYgGlaH7',
    description: 'Label for the first name input on the about-you step',
  },
  lastName: {
    defaultMessage: 'Last name',
    id: '5shJZbEQPG',
    description: 'Label for the last name input on the about-you step',
  },
  firstNamePlaceholder: {
    defaultMessage: 'Jane',
    id: 'fKxJVfRwPW',
    description: 'Placeholder example first name on the about-you step',
  },
  lastNamePlaceholder: {
    defaultMessage: 'Doe',
    id: 'kBz/xL3GqG',
    description: 'Placeholder example last name on the about-you step',
  },
});
